import { render } from "./VelorioVirtual.vue?vue&type=template&id=21e1c173&scoped=true"
import script from "./VelorioVirtual.vue?vue&type=script&lang=js"
export * from "./VelorioVirtual.vue?vue&type=script&lang=js"

import "./VelorioVirtual.vue?vue&type=style&index=0&id=21e1c173&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e1c173"]])

export default __exports__